// extracted by mini-css-extract-plugin
module.exports = {"Link":"Links_Link__3H4bq","LinkFocus":"Links_LinkFocus__wfcMb"};